module.exports = __webpack_public_path__ + "p4_img2.jpg?6f3e02947216d47b2e3849053c74b1b5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p4/p4_img2.jpg
// module id = 121
// module chunks = 0